"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMode = exports.setMode = exports.detachLogger = exports.createLogger = exports.batchLoggers = exports.ConsoleLogger = exports.NamedLogger = void 0;
const types_1 = require("../types");
const console_1 = require("./console");
Object.defineProperty(exports, "ConsoleLogger", { enumerable: true, get: function () { return console_1.ConsoleLogger; } });
const proxy_1 = require("./proxy");
const batch_1 = require("./batch");
Object.defineProperty(exports, "batchLoggers", { enumerable: true, get: function () { return batch_1.batchLoggers; } });
const math_1 = require("../math");
var named_1 = require("./named");
Object.defineProperty(exports, "NamedLogger", { enumerable: true, get: function () { return named_1.NamedLogger; } });
let Mode = false;
const proxies = [];
function createLogger(name, mode = undefined) {
    const result = _createImplementation(mode);
    const proxy = new proxy_1.ProxyLogger(result, name);
    proxies.push(proxy);
    return proxy;
}
exports.createLogger = createLogger;
function detachLogger(instance, terminate = false) {
    const item = (0, math_1.removeItem)(proxies, instance);
    if (item) {
        if (terminate) {
            item.disable();
        }
        return true;
    }
    return false;
}
exports.detachLogger = detachLogger;
function setMode(mode) {
    if (Mode === mode) {
        return;
    }
    Mode = mode;
    if (!Mode) {
        proxies.forEach(l => l.disable());
    }
    else {
        proxies.forEach(l => l.setLogger(_createImplementation()));
    }
}
exports.setMode = setMode;
function getMode() { return Mode; }
exports.getMode = getMode;
const logger = createLogger(null, false);
exports.default = logger;
function _createImplementation(overrideMode = undefined) {
    const mode = overrideMode !== undefined ? overrideMode : Mode;
    switch (mode) {
        case 'console': {
            return console_1.CONSOLE;
        }
        case false: {
            return null;
        }
        default: {
            return types_1.Getter.getValue(mode);
        }
    }
}
//# sourceMappingURL=index.js.map